import { parseElementFromString } from 'anodum';
import linkTypes from '../constants/link-types';
import getLinkConfig from '../accessors/get-link-config';

const hasClipboardExternalLink = (event) => {
  const data = event.clipboardData.getData('text/html');
  const dataHTML = parseElementFromString(`<div>${data}</div>`);
  const links = dataHTML.querySelectorAll('a');

  if (!links) return false;

  return Array.from(links).some((node) => {
    const linkConfig = getLinkConfig(node);

    return linkConfig.linkType === linkTypes.EXTERNAL;
  });
};

export default hasClipboardExternalLink;
